<template>
  <v-container fluid>
    <v-row>
      <v-col xs12>
        <v-card class="elevation-0">
          <v-card-text class="text-sm-left">
            活動方式：下載『遊臺中學英語』APP，使用課程完成學習任務，即有機會獲得獎勵金幣，參加兌換活動。
            <div class="hidden-sm-and-down" style="float: right;">金幣餘額：<span style="font-weight: bold;">{{ $store.getters.user.GoldCount }}</span></div>
          </v-card-text>
          <v-card-text class="text-xs-right hidden-md-and-up">
            金幣餘額：<span style="font-weight: bold;">{{ $store.getters.user.GoldCount }}</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs12 sm6 md3 class="mt-3" v-for="n in items" :key="n.Id">
        <v-card>
          <v-card-row style="background-color: #4a4a66;">
            <v-card-title>
              <span class="white--text" style="height: 2.5em;">{{ n.Name }}</span>
              <v-spacer></v-spacer>
              <!--
              <v-menu id="space" bottom left origin="top right" transition="v-scale-transition">
                <v-btn icon="icon" slot="activator" class="white--text">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-item>
                    <v-list-tile>
                      <v-list-tile-title>Remove Card</v-list-tile-title>
                    </v-list-tile>
                  </v-list-item>
                  <v-list-item>
                    <v-list-tile>
                      <v-list-tile-title>Send Feedback</v-list-tile-title>
                    </v-list-tile>
                  </v-list-item>
                </v-list>
              </v-menu>
              -->
            </v-card-title>
          </v-card-row>

          <v-card-row :img="n.Cover" height="300px" v-if="n.Cover !== null"></v-card-row>
          <v-card-row img="http://placehold.it/320x300" height="300px" v-else></v-card-row>

          <!--
          <v-card-text class="green darken-3 white--text">
            <div v-text="card_text"></div>
          </v-card-text>
          -->
          <v-card-row actions class="mt-0" style="background-color: #4a4a66;">
            <v-btn flat class="white--text">金幣：{{ n.GoldNum }}</v-btn>
            <v-spacer></v-spacer>
            <!--
            <v-btn icon v-on:click.native="add()">
              <v-icon class="white--text">shopping_cart</v-icon>
            </v-btn>
            -->
            <v-btn icon v-on:click.native="buy(n)">
              <v-icon class="white--text">shopping_basket</v-icon>
            </v-btn>
          </v-card-row>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="elevation-0 mt-3">
      <v-card-text>
        注意事項：<br />
        <ul class="pa-3 notice">
          <li>參加者須確保會員帳戶有效性及個人資料正確性，若有無效或錯誤者，視同放棄兌換權利。</li>
          <li>於『遊臺中學英語』APP所獲得的獎勵金幣一經兌換即不得要求取消、退點或更換兌換內容。</li>
          <li>本商品兌換僅限所載之指定商品，不得要求更換商品、加購折抵、將兌換內容折抵、兌換現金，亦不得與其他促銷活動合併使用，商品圖示僅供參考，實際商品請以實物為準。兌換內容之使用方式悉依本公司相關規定為準。</li>
          <li>『遊臺中學英語』APP活動如有任何因電腦、網路、電話、技術或其他不可歸責於本公司之事由，致參加者所填寫之資料有遺失、錯誤、無法辨識或毀損等情形，本公司不負任何法律責任，參加者亦不得異議。</li>
          <li>參加者若以惡意之電腦程式、違反『遊臺中學英語』APP活動相關辦法、偽造、詐欺或其他不正當行為或其他明顯違反活動公平性之方式參加活動者，本公司有權取消其兌換商品資格，已兌換商品方案者，需立即返還，如已使用應予賠償，本公司保留所有法律上之權利。</li>
          <li>本公司有權於公告後隨時以公告或電子郵件通知方式解釋、補充、修改、變更本活動及『遊臺中學英語』APP活動辦法及相關內容，並得隨時取消、終止、變更、修正或暫停本活動及『遊臺中學英語』APP活動。如需詢問遊臺中學英語APP相關訊息，請洽客服專線：02-25782626。</li>
        </ul>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import { mapActions, mapMutations } from 'vuex'
  import api from '../api'

  export default {

    name: 'Shop',

    data () {
      return {
        test: false,
        items: []
      }
    },

    created () {
      var self = this
      this.initBreadcrumb()
      this.addBreadcrumb({
        text: '金幣兌換',
        link: '/shop'
      })

      api.Exchange.Items()
        .then((res) => {
          console.log(res)
          self.items = res.data.Data
        })
    },

    methods: {
      ...mapActions([
        'addToCart'
      ]),

      ...mapMutations([
        'addBreadcrumb',
        'initBreadcrumb'
      ]),

      add (evt) {
        var self = this
        evt = evt || window.event
        var elemDiv = document.createElement('img')
        var attrClass = document.createAttribute('class')
        var attrSrc = document.createAttribute('src')
        attrSrc.value = 'http://placehold.it/150x150'
        attrClass.value = 'addtocart'
        elemDiv.style.cssText = 'top: ' + evt.clientY + '; left: ' + evt.clientX + ';'
        elemDiv.setAttributeNode(attrSrc)
        elemDiv.setAttributeNode(attrClass)
        document.body.appendChild(elemDiv)

        var id = setInterval(frame, 1)
        var pos = {
          top: evt.pageY,
          left: evt.pageX
        }

        var step = {
          top: (32 - pos.top) / 10,
          left: (document.body.clientWidth - 32 - pos.left) / 10
        }

        function frame () {
          if (pos.top <= 32) {
            elemDiv.parentNode.removeChild(elemDiv)
            clearInterval(id)
            self.addToCart({
              name: '測試',
              quantity: 1,
              cost: 100
            })
          } else {
            pos.top += step.top
            pos.left += step.left
            elemDiv.style.top = pos.top + 'px'
            elemDiv.style.left = pos.left + 'px'
          }
        }
      },

      buy (item) {
        this.addToCart({
          name: item.Name,
          quantity: 1,
          cost: item.GoldNum,
          id: item.Id,
          isDigital: item.IsDigital
        })

        this.$router.push('/order')
      }
    }
  }
</script>

<style lang="scss">
  .addtocart {
    width: 100px;
    height: 100px;
    position: absolute;
    opacity: 0.7;
  }

  .notice {
    li {
      list-style-type: decimal;
    }
  }
</style>



// WEBPACK FOOTER //
// Shop.vue?5836ecc0